import type { CodeableConcept, Specimen } from '@medplum/fhirtypes';

export const getCodeableConceptDisplay = (
  concept: CodeableConcept | undefined
): string => {
  if (!concept) {
    return '';
  }

  const coding = concept.coding?.[0];
  return coding?.display ?? coding?.code ?? concept.text ?? '';
};

// Returns the human-friendly specimen type if available (display or code).
export const getSpecimenTypeDisplay = (
  specimen: Specimen
): string | undefined => {
  const coding = specimen.type?.coding?.[0];
  return coding?.display ?? coding?.code ?? undefined;
};

// Removes specimens that are already linked to avoid duplicates in selection lists.
export const filterOutLinkedSpecimens = (
  allSpecimens: Specimen[],
  linkedSpecimens: Specimen[]
): Specimen[] => {
  const linkedIds = new Set(linkedSpecimens.map((s) => s.id));
  return allSpecimens.filter((specimen) => !linkedIds.has(specimen.id));
};
